import { useLogout, WalletWithMetadata } from '@privy-io/react-auth';
import { PublicKey } from '@solana/web3.js';
import { useEffect } from 'react';
import useWalletContext from 'src/hooks/useWalletContext';
import { usePrivyEmbeddedWallet } from 'src/hooks/wallets/privy/usePrivyEmbeddedWallet';

/**
 * Logs out from Privy if the connected Solana Wallet Adapter is a different wallet address
 * used to authenticate with Privy.
 */
export const useSyncPrivyLogout = () => {
	const { user } = usePrivyEmbeddedWallet();
	const { logout: privyLogout } = useLogout();
	const walletContext = useWalletContext();

	useEffect(() => {
		const walletNotConnectedButPrivyIsAuthenticated =
			!walletContext.wallet?.adapter?.publicKey && !!user;

		const solanaWalletAuthorityForPrivyUser = user?.linkedAccounts?.find(
			(account): account is WalletWithMetadata =>
				(account as WalletWithMetadata).connectorType !== 'embedded' &&
				(account as WalletWithMetadata).type === 'wallet'
		);
		const connectedWalletAddressDifferentFromPrivyUser =
			walletContext.wallet?.adapter?.publicKey &&
			solanaWalletAuthorityForPrivyUser &&
			!walletContext.wallet.adapter.publicKey.equals(
				new PublicKey(solanaWalletAuthorityForPrivyUser.address)
			);

		if (
			walletNotConnectedButPrivyIsAuthenticated ||
			connectedWalletAddressDifferentFromPrivyUser
		) {
			privyLogout();
		}
	}, [walletContext.wallet?.adapter?.publicKey, user, privyLogout]);
};
